import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import Img from "gatsby-image";
import ChildContentWrapper from "../styles/ChildContentWrapper";

const ImageWrapperDiv = styled.div`
    label: BodyWrapper;

    align-items: center;
    display: flex;
    flex-direction: column;

    margin: 0;
    padding: 0;

    > div {
        object-fit: contain;
        ${({ image_height }) => (image_height ? `height: ${image_height};` : "height: 100%;")}
        ${({ image_width }) => (image_width ? `width: ${image_width};` : "width: 100%;")}
    }
    > img {
        object-fit: contain;
        ${({ image_height }) => (image_height ? `height: ${image_height};` : "height: 100%;")}
        ${({ image_width }) => (image_width ? `width: ${image_width};` : "width: 100%;")}
    }
`;
const Image = ({ children, image_alt, image_fixed, image_fluid, image_static, image_height, image_width }) => (
    <ImageWrapperDiv image_height={image_height} image_width={image_width}>
        {image_fixed && <Img fixed={image_fixed.childImageSharp.fixed} alt={image_alt} title={image_alt} />}
        {image_fluid && <Img fluid={image_fluid.childImageSharp.fluid} alt={image_alt} title={image_alt} />}
        {image_static && <img src={`${image_static}`} alt={image_alt} title={image_alt} />}
        {children && <ChildContentWrapper>{children}</ChildContentWrapper>}
    </ImageWrapperDiv>
);
export const ImagePropTypes = {

    image_static: PropTypes.string,
    image_fixed: PropTypes.object,
    image_fluid: PropTypes.object,
    image_alt: PropTypes.string,
    image_height: PropTypes.string,
    image_width: PropTypes.string
};
Image.propTypes = ImagePropTypes;
Image.defaultProps = {};
export default Image;
